import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import './style.css';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';

export default function MenuCard({ id, name, price, composition }) {
  const theme = createTheme({
    palette: {
      primary: {
         
              main: '#000',
              dark: '#222',
              contrastText: '#fff',
        
      },
    },
  });
  const [showChildren, setShowChildren] = useState(false);

  useEffect(() => {
    setShowChildren(true);
  }, []);

  const compositionWithLineBreaks = composition.replace(/ \\n /g, '<br>');
  const highlightedComposition = compositionWithLineBreaks.replace(/"([^"]+)":/g, '<span class="highlighted">$1:</span>');

  return (
    <ThemeProvider theme={theme}>
    <div className='menuCard' key={id} >
      <h3 className='menuName'>{name}</h3>
      <span className={`composition ${showChildren ? 'fadeInChild' : ''}`} dangerouslySetInnerHTML={{ __html: highlightedComposition }} />
      {price && ( 
        <Button className={`priceMenu ${showChildren ? 'fadeInChild' : ''}`} variant='contained' size='medium' sx={{fontFamily:'poppins'}} >
          {price.toFixed(2)}  DT
        </Button>
      )}
    
    </div>
    </ThemeProvider>
  );
}
